import LoadingSpinner from '../../../../common/LoadingSpinner'
import ModulePlaceholder from './ModulePlaceholder'

// AI-CONTEXT: See docs/features/livereport-templates-deelnemer.md (T3)
// Nodig omdat elke deelnemerwidget in een template dezelfde twee
// tussentoestanden heeft (gegevens laden / geen voorbeelddeelnemer), en die
// mogen niet als 'kies een deelnemer' of 'geen doelen' gaan lezen.
// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading

/**
 * @param {import('./usePublicPersona').TemplatePersonaStatus|null} templateStatus - Uit usePublicPersona
 * @returns {JSX.Element|null} Iets om te tonen in plaats van de widget, of null om door te gaan
 */
const templatePersonaNotice = (templateStatus) => {
    if (templateStatus === 'loading') return <LoadingSpinner />
    if (templateStatus === 'missing') return <ModulePlaceholder mode="template" />
    return null
}

export default templatePersonaNotice
